function NotFound() {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist. It might have been moved or deleted.</p>
    </div>
  );
}

export default NotFound;